// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.content_ar3c4 {
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  display:-webkit-box;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
      -ms-flex-direction:column;
          flex-direction:column;
  z-index: 0;
}

.content_ar3c4.relative_ZlPa9 {
  position:relative;
  left : auto;
  left : initial;
  right: auto;
  right: initial;
}

.content_ar3c4.inline_SyzZL {
  display : inline-block;
  position : relative;
}

.content_ar3c4.vFill_lrYLy {
  min-height: 100%;
}

.content_ar3c4.horizontal_sutcl {
  -webkit-box-orient:horizontal;
  -webkit-box-direction:normal;
      -ms-flex-direction:row;
          flex-direction:row;
}

.header_n2M_N {
  position:relative;
}

.area_xGZgU {
  -webkit-box-flex:1;
      -ms-flex:1;
          flex:1;
  position:relative;
  overflow:auto;
}

.fillWidth_e4kQH {
  min-width: 100%;
}

.fillHeight_PVCKE {
  min-height: 100%;
}

.footer_cYPr5 {
  position:relative;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/Content.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,OAAO;EACP,QAAQ;EACR,mBAAY;EAAZ,mBAAY;EAAZ,YAAY;EACZ,2BAAqB;EAArB,4BAAqB;MAArB,yBAAqB;UAArB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAc;EAAd,cAAc;EACd,WAAc;EAAd,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAAkB;EAAlB,4BAAkB;MAAlB,sBAAkB;UAAlB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAM;MAAN,UAAM;UAAN,MAAM;EACN,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["\n.content {\n  position:absolute;\n  top:0;\n  left:0;\n  right:0;\n  bottom:0;\n  display:flex;\n  flex-direction:column;\n  z-index: 0;\n}\n\n.content.relative {\n  position:relative;\n  left : initial;\n  right: initial;\n}\n\n.content.inline {\n  display : inline-block;\n  position : relative;\n}\n\n.content.vFill {\n  min-height: 100%;\n}\n\n.content.horizontal {\n  flex-direction:row;\n}\n\n.header {\n  position:relative;\n}\n\n.area {\n  flex:1;\n  position:relative;\n  overflow:auto;\n}\n\n.fillWidth {\n  min-width: 100%;\n}\n\n.fillHeight {\n  min-height: 100%;\n}\n\n.footer {\n  position:relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_ar3c4`,
	"relative": `relative_ZlPa9`,
	"inline": `inline_SyzZL`,
	"vFill": `vFill_lrYLy`,
	"horizontal": `horizontal_sutcl`,
	"header": `header_n2M_N`,
	"area": `area_xGZgU`,
	"fillWidth": `fillWidth_e4kQH`,
	"fillHeight": `fillHeight_PVCKE`,
	"footer": `footer_cYPr5`
};
export default ___CSS_LOADER_EXPORT___;
